import { RouteRecordName } from "vue-router"
import { DisclaimerStep } from "@/modules/enrollment/pages/enroll/components/age-and-location-disclaimer/AgeAndLocationDisclaimerSteps.vue"
import { EnrollmentStep } from "@/modules/enrollment/pages/enroll/EnrollPage.vue"

export enum analyticsEvents {
  PAGE_VIEWED = "page_viewed",
  BUTTON_CLICKED = "button_clicked",
  LOG_IN = "log_in",
  ENROLLMENT_STEPS_PROCEEDED = "enrollment_steps_proceeded",
  ENROLLMENT_REASON_GATHERED = "enrollment_reason_gathered",
  ONBOARDING_CALL_SCHEDULED = "onboarding_call_scheduled",
  USER_LANDED = "user_landed",
  COVERAGE_SEARCHED = "coverage_searched"
}

// Vitable Event Payloads
export type PageViewedProperties = {
  name: RouteRecordName | null | undefined
  path: string
  from_name: RouteRecordName | null | undefined
  from_path: string | null
}

export type ButtonClickedProperties = {
  page_name: string
  cta_text: string
  button_id?: Optional<string>
}

// App Specific Event Payloads

export type EnrollmentStepsProceeded = {
  enrollment_step_name: EnrollmentStep | DisclaimerStep
  page_name: string
}

export type EnrollmentReason = {
  company_benefit_enrollment_id: string
  company_name: string
  enrollment_reason: string
  heard_vitable_before_enroll: Nullable<boolean>
}

export type UserLandedProperties = {
  page_name: RouteRecordName | null | undefined
  from: string | null | undefined
  message_count: string | null | undefined
  plan_type: string | null | undefined
  campaign_version: string | null | undefined
  plan_min_cost: string | null | undefined
  company_id: string | null | undefined
}

export type CoverageSearchedProperties = {
  zip: string
  has_telemedicine_coverage: boolean
  has_in_home_coverage: boolean
  page_name: string
}
